var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowOffices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#ffa330;}.a{stroke:#707070;opacity:0;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-333 -306)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(333 306)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(335.667 308.667)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.892,9.09l6.9,1.371a1.158,1.158,0,0,1,.933,1.144V19.6a1.174,1.174,0,0,1-1.176,1.176H13.5a.388.388,0,0,0,.392-.392v-.392h6.661a.393.393,0,0,0,.392-.392V11.606a.394.394,0,0,0-.306-.384L13.892,9.889Z",
    transform: "translate(-2.92 -2.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18.959,14a.392.392,0,0,1,0,.784H17.392a.392.392,0,0,1,0-.784Z",
    transform: "translate(-3.678 -3.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18.959,17a.392.392,0,0,1,0,.784H17.392a.392.392,0,0,1,0-.784Z",
    transform: "translate(-3.678 -3.819)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18.959,20a.392.392,0,0,1,0,.784H17.392a.392.392,0,0,1,0-.784Z",
    transform: "translate(-3.678 -4.468)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.784,20.363a.392.392,0,1,1-.784,0V9.392a.417.417,0,0,1,.141-.306.412.412,0,0,1,.329-.078l.313.063V20.363Z",
    transform: "translate(-2.812 -2.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.243,23v.392a.388.388,0,0,0,.392.392H9.5a.388.388,0,0,0,.392-.392V23Z",
    transform: "translate(-2.055 -5.117)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.959,5a.392.392,0,1,1,0,.784H8.392a.392.392,0,0,1,0-.784Z",
    transform: "translate(-1.731 -1.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.351,8.392a.388.388,0,0,1-.392.392H8.392a.392.392,0,0,1,0-.784H9.959A.388.388,0,0,1,10.351,8.392Z",
    transform: "translate(-1.731 -1.872)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.959,11a.392.392,0,0,1,0,.784H8.392a.392.392,0,0,1,0-.784Z",
    transform: "translate(-1.731 -2.521)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.959,14a.392.392,0,1,1,0,.784H8.392a.392.392,0,0,1,0-.784Z",
    transform: "translate(-1.731 -3.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.351,14.392a.388.388,0,0,1-.392.392H3.392a.392.392,0,1,1,0-.784H4.959A.388.388,0,0,1,5.351,14.392Z",
    transform: "translate(-0.649 -3.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.959,5a.392.392,0,1,1,0,.784H3.392a.392.392,0,1,1,0-.784Z",
    transform: "translate(-0.649 -1.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.959,8a.392.392,0,1,1,0,.784H3.392a.392.392,0,1,1,0-.784Z",
    transform: "translate(-0.649 -1.872)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.959,11a.392.392,0,1,1,0,.784H3.392a.392.392,0,1,1,0-.784Z",
    transform: "translate(-0.649 -2.521)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.918,18.176a.393.393,0,0,0-.392-.392H5.176a.388.388,0,0,0-.392.392V21.7H4V18.176A1.174,1.174,0,0,1,5.176,17H7.527A1.174,1.174,0,0,1,8.7,18.176V21.7H7.918Z",
    transform: "translate(-0.865 -3.819)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.784,23H8.7v.392a.388.388,0,0,1-.392.392H4.392A.388.388,0,0,1,4,23.392V23Z",
    transform: "translate(-0.865 -5.117)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.371.2,9.984,1.5a1.171,1.171,0,0,1,.987,1.16v4.5L10.658,7.1a.412.412,0,0,0-.329.078.417.417,0,0,0-.141.306V2.664a.4.4,0,0,0-.329-.392L1.246.972A.217.217,0,0,0,1.176.964a.37.37,0,0,0-.251.094.375.375,0,0,0-.141.3V17.672a.393.393,0,0,0,.392.392H3.135v.392a.388.388,0,0,0,.392.392H1.176A1.174,1.174,0,0,1,0,17.672V1.356A1.154,1.154,0,0,1,.415.462,1.176,1.176,0,0,1,1.371.2Z",
    transform: "translate(0 -0.181)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowOffices);
export default __webpack_public_path__ + "static/media/yellowOffices.99944b993aecfba4a29408f4fba99ce9.svg";
export { ForwardRef as ReactComponent };